import Educations from './Educations';
import LocalTrainings from './LocalTrainings';
import ForeignTrainings from './ForeignTrainings';
import AdditionalProfessionalQualifications from './AdditionalProfessionalQualification';
import Publications from './Publications';
import Honours from './Honours';
import Rewards from './Rewards';

export {
  Educations,
  LocalTrainings,
  ForeignTrainings,
  AdditionalProfessionalQualifications,
  Publications,
  Honours,
  Rewards,
};
